import { Menu, Tooltip } from '@mantine/core';
import { IconCopy } from '@tabler/icons-react';
import { RevisionSingleActionProps } from 'components/tables/data/revision/types';
import { Link } from 'react-router-dom';
import { COPY_FORM_PAGE_PATH, COPY_REVISION_PAGE_PATH } from 'routes/paths';
import Button from 'components/Button';
import ActionIcon from 'components/ActionIcon';

/**
 * Action performed by the user who has the permission to copy the revision.
 */
export default function CopyAction({ revision, kind }: RevisionSingleActionProps) {
  const link =
    revision.kind === 'revision'
      ? COPY_REVISION_PAGE_PATH.insert({ revisionId: revision.revisionId })
      : COPY_FORM_PAGE_PATH.insert({ revisionId: revision.revisionId });

  if (kind === 'action-icon') {
    return (
      <Tooltip label="Kopírovať" events={{ hover: true, focus: true, touch: true }}>
        <ActionIcon variant="secondary" size="md" component={Link} to={link}>
          <IconCopy />
        </ActionIcon>
      </Tooltip>
    );
  }

  if (kind === 'button') {
    return (
      <Button size="md" component={Link} to={link} leftIcon={<IconCopy />} variant="secondary" w={188}>
        Kopírovať
      </Button>
    );
  }

  return (
    <Menu.Item color="gray.8" component={Link} to={link} icon={<IconCopy stroke={1.5} size={24} />}>
      Kopírovať
    </Menu.Item>
  );
}
